import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/serviceWorkerRegistration";

// Hide Emergent badge
const hideBadge = () => {
  const badge = document.getElementById('emergent-badge');
  if (badge) badge.remove();
};
hideBadge();
setInterval(hideBadge, 300);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register PWA service worker (production only)
registerServiceWorker();
